import eyecare from "assets/images/banners/home/optho.png";
import aboutus from "assets/images/banners/about/optho.png";
import facility from "assets/images/banners/facility/optho.png";
import facility2 from "assets/images/banners/facility/wavelight.png";
import info from "assets/images/banners/info/optho.png";

export const data = {
  id: "department", 
  label: "Ophthalmology",
  banner: "Expert Eye Care || Restoring Vision, Transforming Lives",
  bannerSize: ["4.375rem", "2.375rem"],
  bannerImg: eyecare,
  aboutImg: aboutus,
  title: "Find the Best Eye Specialist in Chennai – Expert Ophthalmologists",
  description: "Amrit Hospitals offers top-notch eye care services in Chennai. From routine check-ups to advanced treatments, trust our experienced ophthalmologists.",
  keyword: "eye specialist in Chennai",
  url: "https://www.amrithospitals.com/department/opthomology",
  Imageme: "https://www.amrithospitals.com/static/media/optho.966f29f85f82f47f8c43.png",
  about: [ 
    {
      text: "40+",
      subText: "Years of Experience",
    },
    {
      text: "2 Lac+",
      subText: "Surgeries",
    },
    {
      text: "4.8 Lac+",
      subText: "Happy Patients",
    },
    {
      text: "25000+",
      subText: "Specs Removed",
    },
  ],
  facilityImg: facility,
  infoImg: info,
  info: {
    heder: "Powered By",
    subheader: "Artificial Intelligence",
    point1: "NO BLADE, NO PAIN",
    point2: "NO STITCH, NO INJECTION",
  },
  facility: {
    mainHeader: "Freedom From Glasses In Just 9 Seconds",
    subHeader: "Smile Pro Surgery can be life changing",
    content:
      "Dreamed of becoming a pilot, a model, or anything you've ever desired? In just 9 seconds, Smile Pro Surgery can remove your specs and change your life forever. Embrace a future of limitless possibilities with crystal-clear vision!",
  },
  facilityImg2: facility2,
  facility2: {
    mainHeader: "WaveLight Plus InnovEyes Technology",
    subHeader: "AI-Guided, Ultra Fast, Pain-Free Vision Correction",
    content:
      "Tired of depending on glasses or contact lenses? Get your vision corrected in just 15 seconds per eye with an AI-guided, laser procedure that delivers unmatched precision and safety. Experience faster recovery and clearer sight — all within 24 hours.",
  },
  serviceHeader: "Super-Specialty Eye Care",
  services: [

    {
      id: "WaveLightPlusInnovEyesTechnology",
      label: "WaveLight Plus InnovEyes Technology",
      content:
        "Step into the future of eye health with AI-guided vision correction that combines speed, precision, and comfort like never before.",
        customLink: "/wavelight-plus",
    },
    {
      id: "smileProSurgery",
      label: "Smile Pro Surgery",
      content:
        "Experience the world's first robotic, flapless, and minimally invasive laser vision correction procedure, restoring perfect vision in just 9 seconds.",
    },
    {
      id: "contouraVision",
      label: "Contoura Vision - Specs Removal",
      content:
        "Achieve superior visual acuity with this advanced LASIK technique that customizes treatment based on the microscopic contours of your cornea.",
    },
    {
      id: "cataract",
      label: "Cataract",
      content:
        "Restore clarity and improve vision with our advanced cataract surgery options, ensuring a brighter, clearer future.",
    },
    {
      id: "glaucoma",
      label: "Glaucoma",
      content:
        "Protect your vision with our comprehensive glaucoma management and treatment plans, tailored to prevent and control eye pressure.",
    },
    {
      id: "corneaAndKeratoconus",
      label: "Cornea and Keratoconus",
      content:
        "Specialized care for corneal diseases and keratoconus, offering treatments to improve corneal health and visual outcomes.",
    },
    {
      id: "pediatricOphthalmology",
      label: "Pediatric Ophthalmology kkk",
      content:
        "Dedicated eye care for children, addressing vision issues early to ensure optimal eye health and development.",
    },
    {
      id: "retina",
      label: "Retina",
      content:
        "Advanced diagnostic and treatment options for retinal conditions, preserving and enhancing your vision with cutting-edge care.",
    },
    {
      id: "oculoplastyAndCosmeticEnhancement",
      label: "Oculoplasty and Cosmetic Enhancement",
      content:
        "Enhance your appearance and eye function with our expert oculoplastic and cosmetic procedures.",
    },
    {
      id: "contactLenses",
      label: "Contact Lenses",
      content:
        "Find the perfect contact lenses to suit your lifestyle and visual needs, with personalized fitting and care.",
    },
    {
      id: "neuroOphthalmology",
      label: "Neuro Ophthalmology",
      content:
        "Specialized care for complex eye conditions related to the nervous system, ensuring comprehensive diagnosis and treatment.",
    },
    {
      id: "lowVisionSyndrome",
      label: "Low Vision Syndrome",
      content:
        "Customized solutions to improve quality of life and maximize remaining vision for those with low vision syndrome.",
    },
  ],
faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1. Why is Amrit Hospital the Best Gynaecology Hospital in Chennai?",
        content:
          "Amrit Hospital is considered the best for gynaecology treatment, providing professional care in maternity, fertility, and laparoscopic surgery. Our highly qualified gynaecologists use state-of-the-art medical technology for customized treatment to provide safe and successful treatment. We emphasize high-quality women's healthcare services, which makes us the best gynaecology hospital in Chennai.",
      },
      {
        label: "2. Are the fertility treatments at Amrit Hospital advanced?",
        content:
          "Yes, we offer high-success rate fertility treatments such as IVF, IUI, and ovulation induction. Our experienced gynaecologists use the latest reproductive methods for safe and successful conception treatment. Our patient-centric approach assists couples in overcoming infertility issues, which has made our hospital one of the most popular gynaecology fertility hospitals in Chennai.",
      },
      {
        label: "3. What is the treatment of PCOS and endometriosis in Amrit Hospital?",
        content:
          "In Amrit Hospital, we manage PCOS and endometriosis with overall PCOS and endometriosis treatment under hormonal therapy, lifestyle modifications, and advanced laparoscopic management. Our Chennai best gynaecologists attempt to detect solutions for long-term cycle control, controlling pain, and enhancing fertility. Utilizing the latest technology, we address the underlying reason, which brings customized efficient treatment for all-around women's healthcare in Chennai.",
      },
      {
        label: "4. What kind of laparoscopic procedures are done at Amrit Hospital?",
        content:
          "We offer minimally invasive laparoscopic surgery for fibroids, ovarian cysts, endometriosis, and hysterectomy. These revolutionary procedures guarantee rapid recovery, fewer discomforts, and minimal scarring. Our professional gynaecologists equipped with the finest medical technology make us one of the best gynaecology hospitals in Chennai to perform laparoscopic surgery.",
      },
      {
        label: "5. Why would I choose Amrit Hospital to treat menopause?",
        content:
          "Menopause is a hormonal change in health, but our professional gynaecologists give personalized hormone treatment, diet, and lifestyle counseling. We manage osteoporosis, heart disease, and menopausal syndrome comfortably. Our treatment of personalized care ensures long-term health; thus, we are the most reliable gynaecology hospital in Chennai to manage menopause.",
      },
      {
        label: "6. Does Amrit Hospital provide teenage and adolescent gynaecology facilities?",
        content:
          "Yes, we also offer teenage girls specialized gynaecology services such as regulation of the menstrual cycle, hormonal disorder treatment, and HPV vaccination. Our highly experienced gynaecologists offer advice for puberty-related issues in a safe and comfortable environment. We educate young girls about reproductive health and offer them the best care from professional experts at our best hospital in Chennai.",
      },
      {
        label: "7. How can I schedule an appointment with Amrit Hospital's top gynaecologist?",
        content:
          "Taking an appointment is an easy task. Patients can reach out to our hospital either through calling or through our online appointment booking system. The staff at our facility will organize an appointment with Chennai’s best gynaecologists in a time slot that is convenient for you. We offer prompt, efficient treatment to you.",
      },
    ],
  },
};


